module.exports = {
      id: "ic-btceth-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-btceth-usage",
      toString: function () {
        return this.url;
      }
    }